import React, { useEffect } from 'react';
import { Type } from '@spotify-internal/encore-web';
// import { useTranslation } from 'providers/translations/TranslationProvider';

import { IsHelpfulAnswerEnum } from '../../hooks/useIsHelpfulAnswer';
import MessageUsButton from '../ThanksMessage/MessageUsButton';

import { StyledDialogAlert, StyledDialogHeader, StyledActions } from './styles';

interface ThanksDialogProps {
  answered?: IsHelpfulAnswerEnum;
  trackMessageUsLink: () => void;
  onClose: () => void;
}

const ThanksDialog = ({ answered, trackMessageUsLink, onClose }: ThanksDialogProps) => {
  // const { t } = useTranslation();

  // close by itself after 3 seconds
  useEffect(() => {
    if (answered === IsHelpfulAnswerEnum.no) {
      return;
    }

    const timer = window.setInterval(() => {
      onClose();
      window.clearTimeout(timer);
    }, 3000);

    // eslint-disable-next-line consistent-return
    return () => window.clearTimeout(timer);
  }, [answered, onClose]);

  return (
    <StyledDialogAlert
      id="thanks-dialog"
      aria-live="polite"
      data-testid="thanks-dialog"
      colorSet="announcement"
      body={
        <StyledDialogHeader>
          <Type as="p" variant="ballad">
            {/* t('feedback_thanks_message')*/}
            Thanks for your feedback!
          </Type>
        </StyledDialogHeader>
      }
      footer={
        answered === IsHelpfulAnswerEnum.no ? (
          <StyledActions>
            <MessageUsButton trackMessageUsLink={trackMessageUsLink} />
          </StyledActions>
        ) : null
      }
    />
  );
};

export default ThanksDialog;
